import { Dossier } from "./IDossiers";

export interface DepositDocument extends Partial<Dossier> {
    ECLDEP_REF: number;
    ECLDEPFILE_REF: number;
    ECLDEPFILE_TITRE: string;
    ECLDEPFILE_PATH_AND_FILENAME: string;
    ECLDEP_DATE?: string;
    ECLDEP_OBJET?: string;
    ECLDEP_COMMENT?: string;
    ECLDEP_TRAITEMENT?: boolean | 0 | 1;
    ECLDEP_TRAITEMENT_COMMENT?: string;
    ECLDEPFILE_TRAITEMENT?: FileDepositStatus;
    ECLDEPFILE_TRAITEMENT_COMMENT?: string;
}

export enum FileDepositStatus {
    'Envoyé' = 0,
    'Accepté' = 1,
    'Rejeté' = 2
}